module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/icons/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ./src/assets/styles/icons/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = styles